import { deserialise } from "kitsu-core"
import { message } from "antd"

import * as AuthHelper from "helpers/auth.helper"
import { API, apiClient, call, generic } from "api"

// TODO: make it dry
export default class UsersService {
  static commonLogin = async ({ values, pageState, stateApiStatusKey, apiEndPoint }) => {
    let response
    try {
      pageState[stateApiStatusKey] = "pending"
      const { method, url } = apiEndPoint
      response = await call(apiClient()[method], url, { auth: values })
    } catch (e) {
      pageState[stateApiStatusKey] = "rejected"
      if (e.name === "ServerNotReachableError") {
        message.destroy()
        message.error("Unable to reach server, please try after some time")
        pageState.serverNotReachable = true
        return
      }
      message.destroy()
      message.error("An error occurred. Please try after some time")
      throw e
    }

    // console.log('response', response)
    const deserialisedData = await deserialise(response.data)
    console.log("deserialisedData", deserialisedData)

    if (deserialisedData.errors) {
      pageState.loginErrors = deserialisedData.errors
      pageState[stateApiStatusKey] = "fulfilled"
      return
    }

    delete pageState.loginErrors

    if (!deserialisedData.data || (deserialisedData.data && !deserialisedData.data.jwt)) {
      message.destroy()
      message.error("Error logging in. Please try the Login page.")
      pageState[stateApiStatusKey] = "fulfilled"
      return
    }

    AuthHelper.setToken(deserialisedData.data.jwt)
    AuthHelper.setUserType(deserialisedData.data.user_type)

    pageState[stateApiStatusKey] = "fulfilled"
  }

  static register = async ({ values, pageState }) => {
    let response
    try {
      pageState.API_USERS_REGISTER_STATUS = "pending"
      const { method, url } = API.users.register
      response = await call(apiClient()[method], url, { user: values })
    } catch (e) {
      pageState.API_USERS_REGISTER_STATUS = "rejected"
      if (e.name === "ServerNotReachableError") {
        message.destroy()
        message.error("Unable to reach server, please try after some time")
        pageState.serverNotReachable = true
        return
      }
      message.destroy()
      message.error("An error occurred. Please try after some time")
      throw e
    }

    // console.log('response', response)
    const deserialisedData = await deserialise(response.data)
    // console.log('deserialisedData', deserialisedData)

    if (deserialisedData.errors) {
      pageState.registerErrors = deserialisedData.errors
      pageState.stepStatus = "process"
      pageState.API_USERS_REGISTER_STATUS = "fulfilled"
      return
    }

    delete pageState.registerErrors

    if (!deserialisedData.data || (deserialisedData.data && !deserialisedData.data.jwt)) {
      message.destroy()
      message.error("Error logging in. Please try the Login page.")
      pageState.API_USERS_REGISTER_STATUS = "fulfilled"
      return
    }

    AuthHelper.setToken(deserialisedData.data.jwt)
    AuthHelper.setUserType(deserialisedData.data.user_type)

    pageState.currentStep = "school"
    pageState.stepStatus = "process"
    pageState.API_USERS_REGISTER_STATUS = "fulfilled"
  }

  static login = async ({ values, pageState }) => {
    console.log("UsersService.login")
    await this.commonLogin({
      values,
      pageState,
      stateApiStatusKey: "API_USERS_LOGIN_STATUS",
      apiEndPoint: API.users.login,
    })
  }

  static firebaseLogin = async ({ values, pageState }) => {
    console.log("UsersService.firebaseLogin")
    await this.commonLogin({
      values,
      pageState,
      stateApiStatusKey: "API_USERS_FIREBASE_LOGIN_STATUS",
      apiEndPoint: API.users.firebaseLogin,
    })
  }

  static show = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_SHOW_STATUS",
      stateDataKey: ["user", "courses", "payments"],
      stateErrorKey: ["userErrors", "coursesErrors", "paymentsErrors"],
      apiEndpoint: API.users.me,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "User could not be fetched",
    })
  }

  static edit = async ({ pageState, values }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_EDIT_STATUS",
      stateDataKey: ["user"],
      stateErrorKey: ["userErrors"],
      apiEndpoint: API.users.edit,
      apiUrlReplacements: {},
      apiData: { user: { ...values } },
      errorMessage: "User details could not be updated",
    })
  }
}
